import { render, staticRenderFns } from "./CheckInAddModal.template.vue?vue&type=template&id=180a54e8&scoped=true&"
var script = {}
import style0 from "./CheckInAddModal.template.vue?vue&type=style&index=0&id=180a54e8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180a54e8",
  null
  
)

export default component.exports